import { createSlice } from '@reduxjs/toolkit';

const widgetSlice = createSlice({
  name: 'widget',
  initialState: {
    widgetIsSelected: false,
    widgetType: null,
    dimensions: null,
    usgsProvisonalAccepted: false,
  },
  reducers: {
    setWidgetIsSelected: (state, action) => {
      state.widgetIsSelected = !!action.payload; // Ensure it's a boolean
    },
    setWidgetType: (state, action) => {
      state.widgetType = action.payload;
    },
    setDimensions: (state, action) => {
      state.dimensions = action.payload;
    },
    setUsgsProvisonalAccepted: (state, action) => {
      state.usgsProvisonalAccepted = !!action.payload;
    },
  },
});

export const { setWidgetIsSelected, setWidgetType, setDimensions, setUsgsProvisonalAccepted } =
  widgetSlice.actions;

// Selectors
export const selectWidgetIsSelected = (state) => state.widget.widgetIsSelected;
export const selectWidgetType = (state) => state.widget.widgetType;
export const selectDimensions = (state) => state.widget.dimensions;
export const selectUsgsProvisonalAccepted = (state) => state.widget.usgsProvisonalAccepted;

export default widgetSlice.reducer;
